import { LegalLayout } from "@/components/shared/LegalLayout";
import { NextSeo } from "next-seo";

export default function RefundPolicy() {
  return (
    <>
      <NextSeo
        title="Crayo AI | Refund Policy"
        description="Refund Policy for Crayo AI: the all-in-one platform for creating viral TikTok clips in seconds."
      />
      <LegalLayout content={content} eyebrow="Refund Policy" lastUpdated="January 24, 2025" />
    </>
  );
}

const content = {
  title: "Refund Policy",
  description:
    "Refund Policy for Crayo AI: the all-in-one platform for creating viral TikTok clips in seconds.",
  effectiveDate: "January 24, 2025",
  sections: [
    {
      title: "1. No Refunds",
      content: [
        "ALL SALES ARE FINAL. The Company does not offer refunds for any products or services under any circumstances once a transaction has been completed.",
        "By making a purchase, you explicitly acknowledge and agree that you have read, understood, and accepted this strict no-refund policy.",
        "No exceptions will be made to this no-refund policy, including but not limited to claims of dissatisfaction, accidental purchases, or changes in personal circumstances.",
      ],
    },
    {
      title: "2. Cancellation Policy",
      content: "",
      subSections: [
        {
          title: "2.1 Eligibility:",
          content:
            "All subscribers may cancel at any time at their choosing, no reason or approval required. You may do so in the dashboard following the steps outlined below.",
        },
        {
          title: "2.2 Cancellation Process:",
          content: "To cancel your subscription, follow these steps:",
          subSections: [
            {
              title: "",
              content: [
                'Go to <Link className="text-blue-600 hover:underline" href="https://crayo.ai/dashboard">crayo.ai/dashboard</Link>',
                "Click on your profile picture in the top right corner",
                'Select "Settings"',
                'Press the large red "Cancel" button',
              ],
            },
          ],
        },
        {
          title: "2.3 Service Continuation:",
          content:
            "Upon cancellation, the plan will remain active until the end of the current billing cycle. The subscriber will continue to have full access to all features during this period.",
        },
        {
          title: "2.4 No Additional Charges:",
          content:
            "No further payments will be collected after the cancellation has been processed.",
        },
        {
          title: "2.5 Data Retention:",
          content:
            "Generally, data will be kept in case of reactivation. However, the Company reserves the right to delete any data upon cancellation. Please contact support if you wish to have your data removed in accordance to applicable privacy laws and our policy provisions.",
        },
      ],
    },
    {
      title: "3. Contact Information",
      content: "For any questions or concerns regarding this Refund Policy, please contact us:",
      subSections: [
        {
          title: "",
          content: [
            'Email: <Link className="text-blue-600 hover:underline" href="mailto:support@crayo.ai">support@crayo.ai</Link>',
            'Discord: <Link className="text-blue-600 hover:underline" href="https://crayo.ai/discord">Crayo AI Discord Server</Link>',
          ],
        },
      ],
    },
    {
      title: "4. Amendments",
      content: [
        "The Company reserves the right to modify this Policy at any time, effective upon posting of an updated version on our website.",
        'You are responsible for regularly reviewing this Policy to stay informed of updates. The "Effective Date" at the beginning of this document indicates when the Policy was last revised.',
      ],
    },
    {
      title: "5. Governing Law",
      content:
        "This Policy shall be governed by and construed in accordance with the laws of the jurisdiction in which Crayo, Inc. is registered, without regard to its conflict of law provisions.",
    },
  ],
};
